import store from '../store/store';
import { setLocalOverride } from '../utils/localOverrides';

export default function setApplicationSettingOverrideAction(setting: string, value: any) {
    setLocalOverride(setting, value);
    store.overrides[setting] = value;
}
